import { z } from "zod";
import { ISODateSchema, ULIDSchema } from "./primitives.js";
import { UserSchema } from "./user.js";
import { RoleSchema } from "./membership.js";
export const MembershipSummarySchema = z.object({
    householdId: ULIDSchema("hh"),
    householdName: z.string().min(1).max(80),
    timezone: z.string().min(1).max(64).optional(),
    role: RoleSchema,
    joinedAt: ISODateSchema,
});
export const MeResponseSchema = z.object({
    user: UserSchema,
    memberships: z.array(MembershipSummarySchema),
});
export const SetActiveHouseholdRequestSchema = z
    .object({
    householdId: ULIDSchema("hh"),
})
    .strict();
//# sourceMappingURL=me.js.map